import React from 'react';
import { AdUnit } from './ad-unit';

export function AdUnitSwitch(props) {
  return <AdUnit {...props} />;
}
